export const CHART2_REQUEST = "CHART2_REQUEST";
export const CHART2_SUCCESS = "CHART2_SUCCESS";
export const CHART2_FAILURE = "CHART2_FAILURE";
